import React, { useMemo, useState } from "react";
import { Card, Alert, Spinner } from "react-bootstrap";
import { Table } from "react-bootstrap";
import "./financeiro.css";
import moment from "moment";
import Swal from "sweetalert2";
import { successToast } from "../../../../../components/DommusToast";
import ProcessoService from "../../../../../services/ProcessoService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faBarcode } from "@fortawesome/free-solid-svg-icons";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import DommusLoading from "../../../../../components/DommusLoading/DommusLoading";

// Parcelas quitadas não geram boleto
const STATUS_SEM_BOLETO = ["quitada"];

export default function Financeiro({ financeiro, erro, idProcesso, conciliando }) {
  // Id da parcela cujo boleto está sendo carregado (null = nenhum)
  const [loadingBoletoId, setLoadingBoletoId] = useState(null);

  function handleBuscaBoleto(parcela, chavesExternas) {
    if (!idProcesso || !parcela?.id) {
      Swal.fire({
        titleText: "Boleto não disponível, entre em contato conosco.",
        text: "",
        icon: "warning",
      });
      return;
    }

    setLoadingBoletoId(parcela.id);

    ProcessoService.buscarBoleto(idProcesso, parcela.id, chavesExternas)
      .then((res) => {
        const retorno = res.data;
        if (retorno && retorno.length > 0 && retorno[0]?.urlReport) {
          Swal.fire({
            titleText: `2ª via de boleto`,
            text: "Seu boleto está disponível para download",
            icon: "info",
            showCloseButton: false,
            showCancelButton: true,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText: "Baixar boleto",
            denyButtonText: "Copiar código",
            cancelButtonText: "Cancelar",
            customClass: {
              confirmButton: "btn btn-success mr-3",
              cancelButton: "btn btn-secondary mr-3",
              denyButton: "btn btn-primary mr-3",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.open(retorno[0].urlReport, "_blank");
            } else if (result.isDenied) {
              navigator.clipboard.writeText(retorno[0].digitableNumber);
              successToast.fire({
                text: "Link copiado para a área de transferência.",
              });
            }
          });
        } else {
          Swal.fire({
            titleText: "Boleto não disponível, entre em contato conosco.",
            text: "",
            icon: "warning",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          titleText: "Ocorreu um erro ao buscar o boleto.",
          text: "Tente novamente ou entre em contato conosco.",
          icon: "error",
        });
      })
      .finally(() => {
        setLoadingBoletoId(null);
      });
  }

  const dadosFinanceiros = useMemo(() => {
    if (conciliando) {
      return (
        <Card.Body className="cardTabela">
          <div style={{ position: "relative", height: "80px" }}>
            <DommusLoading loadWrapperPosition="absolute" fundo="rgba(255,255,255,0.8)" />
          </div>
        </Card.Body>
      );
    }

    if (financeiro) {
      return (
        <>
          <Card.Body className="cardTabela">
            <div className="conteudoFianceiro">
              <Table className="tebelaFinanceiro" striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tipo Parcela</th>
                    <th>Vencimento</th>
                    <th>Valor(R$)</th>
                    <th>2ª Via</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {financeiro.map((item, index) => {
                    const podeGerarBoleto = !STATUS_SEM_BOLETO.includes(item.statusParcela);
                    const carregandoEstaLinha = loadingBoletoId === item.id;

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.tipo}</td>
                        <td>{moment(item.vencimento).format("DD/MM/YYYY")}</td>
                        <td>{item.valor}</td>
                        <td align="center">
                          {podeGerarBoleto && (
                            carregandoEstaLinha ? (
                              <Spinner animation="border" variant="dark" size="sm" />
                            ) : (
                              <FontAwesomeIcon
                                title={item.geraBoleto ? "Emitir 2ª via do boleto" : "Boleto não disponível"}
                                icon={faBarcode}
                                color={item.geraBoleto ? "#444" : "#aaa"}
                                style={{ cursor: "pointer", fontSize: 18 }}
                                onClick={() => {
                                  if (item.geraBoleto) {
                                    handleBuscaBoleto(item, item.chaves_externas);
                                  } else {
                                    Swal.fire({
                                      titleText: "Boleto não disponível, entre em contato conosco.",
                                      text: "",
                                      icon: "warning",
                                    });
                                  }
                                }}
                              />
                            )
                          )}
                        </td>
                        <td>
                          {item.statusParcela === "quitada" ? (
                            <FontAwesomeIcon
                              title="Quitada"
                              icon={faCheckCircle}
                              color="green"
                            />
                          ) : item.statusParcela === "avencer" ? (
                            <FontAwesomeIcon
                              title="À vencer"
                              icon={faExclamationCircle}
                              color="orange"
                            />
                          ) : item.statusParcela === "atrasada" ? (
                            <FontAwesomeIcon
                              icon={faTimesCircle}
                              color="red"
                              title="Atrasada"
                            />
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </>
      );
    } else {
      return (
        <Alert variant="warning">
          <Spinner animation="border" variant="dark" size="sm" />
          <span style={{ paddingRight: "10px" }}>Carregando Dados</span>
        </Alert>
      );
    }
  }, [financeiro, loadingBoletoId, conciliando]);

  return (erro && <Alert>{erro}</Alert>) || dadosFinanceiros;
}
